import { render } from "./ExclamationMark.vue?vue&type=template&id=0f428cc6&scoped=true"
import script from "./ExclamationMark.vue?vue&type=script&lang=js"
export * from "./ExclamationMark.vue?vue&type=script&lang=js"

import "./ExclamationMark.vue?vue&type=style&index=0&id=0f428cc6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f428cc6"]])

export default __exports__